import * as React from "react";
const SvgGanttLimiteSeta = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8.66026, height: 6, viewBox: "0 0 8.66026 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "seta", d: "M4.33013 0L8.66025 6H0L4.33013 0Z", fill: "#F87171" }));
export default SvgGanttLimiteSeta;
